import moment from 'moment'

import useAgent from 'hooks/use-agent'
import useAuth from 'hooks/use-auth'

export default function useCompanyReportData({
  skipCompanyDetailsRequest = false,
  interval = 10000,
  shouldCache = true
} = {}) {
  // get report data for tiles
  const startDate = moment().format('YYYY-MM-01')
  const endDate = moment().add(1, 'month').format('YYYY-MM-01')

  // get previous month's data also
  const endDate2 = startDate
  const startDate2 = moment().subtract(1, 'month').format('YYYY-MM-01')

  const {
    data: [thisMonth, prevMonth],
    isLoading
  } = useAgent(
    [
      `/reports/companies?startDate=${startDate}&endDate=${endDate}`,
      `/reports/companies?startDate=${startDate2}&endDate=${endDate2}`
    ],
    [[], []],
    {
      shouldCache,
      interval
    }
  )

  const activeClients = thisMonth?.gremlin_metrics?.unique_active_hosts ?? 0
  const attackedHosts = thisMonth?.gremlin_metrics?.unique_hosts_attacked ?? 0
  const attackedHostsLastMonth =
    prevMonth?.gremlin_metrics?.unique_hosts_attacked ?? 0
  const activeUsers = thisMonth?.gremlin_metrics?.unique_active_users ?? 0
  const attacksThisMonth = thisMonth?.gremlin_metrics?.attacks_run ?? 0
  const attacksLastMonth = prevMonth?.gremlin_metrics?.attacks_run ?? 0
  const uniqueTargetsHost = thisMonth?.gremlin_metrics?.unique_targets_host ?? 0
  const uniqueTargetsContainer =
    thisMonth?.gremlin_metrics?.unique_targets_container ?? 0
  const uniqueTargetsApplication =
    thisMonth?.gremlin_metrics?.unique_targets_application ?? 0

  const daysThisMonth = Number(moment().format('D'))
  const daysLastMonth = moment()
    .subtract(1, 'month')
    .startOf('month')
    .daysInMonth()

  const { companyId } = useAuth()

  const {
    data: [[companyData]],
    isCompanyLoading,
    doCompanyFetch
  } = useAgent([`/companies/${companyId}`], [[{ orgs: [] }]], {
    shouldCache,
    skipRequest: skipCompanyDetailsRequest
  })

  return {
    activeClients,
    attackedHosts,
    attackedHostsLastMonth,
    activeUsers,
    attacksThisMonth,
    attacksLastMonth,
    daysThisMonth,
    daysLastMonth,
    uniqueTargetsHost,
    uniqueTargetsContainer,
    uniqueTargetsApplication,
    companyData,
    isCompanyLoading,
    isLoading,
    doCompanyFetch
  }
}
